import { Component, OnInit } from '@angular/core';
import { PayService } from '../service/pay.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-affaires-achats',
  templateUrl: './affaires-achats.component.html',
  styleUrls: ['./affaires-achats.component.css'],
  standalone: false
})
export class AffairesAchatsComponent implements OnInit {
  accountNumber: any;
  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject();
  achalist: any[] = [];
  allAchats: any[] = [];
  monthOptions: { value: string; label: string }[] = [];
  selectedMonth: string;
  sigle: string;
  bDescription: string;
  safeName: string;
  constructor(private userService: PayService, private routerActivate: ActivatedRoute, private router: Router) { }

  ngOnInit(): void {
    $('#utilisateur').DataTable().init;
    this.routerActivate.params.subscribe(params => {
      this.accountNumber = params['id']
    });
    this.sigle = localStorage.getItem('sigle');
    const raw = localStorage.getItem("bDescription");
    this.bDescription = raw ? decodeURIComponent(raw) : '';
    this.safeName = encodeURIComponent(this.bDescription);
    this.getAchatslist();
  }

  getAchatslist() {
    $('#utilisateur').DataTable().destroy();
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      responsive: true
    };
    this.userService.getUtilisateursBaccountAchats(this.accountNumber).subscribe((data: any[]) => {
      this.dtTrigger.next();
      this.allAchats = data || [];
      this.buildMonthOptions();
      this.applyMonthFilter(this.selectedMonth);
      console.log(this.achalist);

    })
  }

  applyMonthFilter(monthKey: string) {
    this.selectedMonth = monthKey || this.getCurrentMonthKey();
    this.achalist = this.allAchats.filter(a => this.getMonthKey(a?.dateAchat) === this.selectedMonth);
  }

  private buildMonthOptions() {
    const months = new Set<string>();
    const current = this.getCurrentMonthKey();
    months.add(current); // always include current month
    this.allAchats.forEach(a => {
      const key = this.getMonthKey(a?.dateAchat);
      if (key) { months.add(key); }
    });
    this.monthOptions = Array.from(months)
      .sort((a, b) => b.localeCompare(a)) // newest first
      .map(key => ({ value: key, label: this.formatMonthLabel(key) }));
    this.selectedMonth = current;
  }

  private getMonthKey(dateInput: any): string {
    const d = new Date(dateInput);
    if (isNaN(d.getTime())) { return ''; }
    const month = String(d.getMonth() + 1).padStart(2, '0');
    return `${d.getFullYear()}-${month}`;
  }

  private getCurrentMonthKey(): string {
    return this.getMonthKey(new Date());
  }

  private formatMonthLabel(key: string): string {
    const [year, month] = key.split('-').map(Number);
    const d = new Date(year, (month || 1) - 1);
    return d.toLocaleString('fr-FR', { month: 'long', year: 'numeric' });
  }


}
